import React from 'react'

import css from './EmbedLayout.scss'

const EmbedLayout = ({ children }) => (
  <div className={css.embedRoot}>{children}</div>
)

EmbedLayout.propTypes = {
  children: React.PropTypes.node
}

export default EmbedLayout
